import React from 'react';
import { Building2 } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-400">
      <div className="container mx-auto px-6">
        {/* Main footer content */}
        <div className="py-16 space-y-12">
          {/* Top section */}
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 pb-12 border-b border-gray-800">
            <div className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/a4svjjfw_400dpiLogoCropped.png" 
                alt="SOGI Logo" 
                className="h-14 w-auto brightness-0 invert"
              />
              <div className="ml-2">
                <div className="text-2xl font-bold text-white">SOGI</div>
                <div className="text-sm text-gray-500">Excellence en construction depuis {companyInfo.yearsExperience} ans</div>
              </div>
            </div>
            
            {/* Navigation */}
            <nav className="flex flex-wrap gap-6">
              {[
                { label: 'Accueil', id: 'hero' },
                { label: 'Services', id: 'services' },
                { label: 'Historique', id: 'history-values' },
                { label: 'Réalisations', id: 'projects' },
                { label: 'Contact', id: 'contact' }
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-sm hover:text-yellow-400 transition-colors"
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Bottom section */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p>
              © {currentYear} {companyInfo.name}. Tous droits réservés.
            </p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-yellow-400 transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-yellow-400 transition-colors">Confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
